import { STASH_ANALYTICS_REPORT_DATA } from "~/actions/definitions";

export default (state = null, { type, payload }) => {
    if(type !== STASH_ANALYTICS_REPORT_DATA) return state;
    return payload;
};